export const SmallMobile = '@media screen and (max-width: 25em)';
export const LargeMobile = '@media screen and (max-width: 40em)';
export const Tablet = '@media screen and (max-width: 50em)';
export const Desktop = '@media screen and (min-width: 40em)';
export const MediumDesktop = '@media screen and (min-width: 50em)';
export const Safari = '@media not all and (min-resolution:.001dpcm)';
